import MARKDOWN from "@/legal/velocity-plans-schedule.md?raw";
import LegalShell from "./_LegalShell";
import LegalMarkdown from "./_LegalMarkdown";
import { LEGAL_UPDATED } from "@/legal/version";

export default function VelocityPlans() {
  return (
    <LegalShell
      title="Velocity Plans Schedule"
      updated={LEGAL_UPDATED}
      description="Velocity Plans Schedule for ElectricSheepHQ engineering retainers: plans, monthly fees, Velocity Points, Initial Term, and add-ons."
      canonicalPath="/velocity-plans"
    >
      <LegalMarkdown markdown={MARKDOWN} />
    </LegalShell>
  );
}
